import styled from 'styled-components/macro';

export const VerticalDivider = styled.span`
  height: 20px;
  width: 1px;
  border-right: solid 1px var(--cogs-border-default);
`;

export const HorizontalDivider = styled.span`
  height: 1px;
  display: flex;
  margin-left: -1rem;
  margin-right: -1rem;
  border-bottom: solid 1px var(--cogs-border-default);
`;
